import classNames from "classnames";
import { ExclamationIcon } from "../../AscIcons";
import AscFileCard, { AscFileCardProps } from "../AscFileCard/AscFileCard";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscActivityInfoCard.module.scss";

export interface AscActivityInfoCardProps {
  className?: string;
  text?: string;
  image?: string;
  files?: AscFileCardProps[];
}

export default function AscActivityInfoCard({
  className,
  text,
  image,
  files,
}: AscActivityInfoCardProps) {
  return (
    <AscGenericCard
      data-testid="asc-activity-info-card"
      className={classNames(styles.ground, className)}
      title={null}
      coverImageUrl={null}
      contentClassName={styles.content}
      footerClassName={classNames(styles.footer, {
        [styles.hideFooter]: !files?.length,
      })}
      footer={
        <>
          <div>
            <div className={styles.filesTitle}>Additional files</div>
          </div>
          <div className={styles.files}>
            {files?.map((file, index) => (
              <AscFileCard key={index} {...file} />
            ))}
          </div>
        </>
      }
    >
      <div className={styles.iconWrapper}>
        <ExclamationIcon className={styles.infoIcon} />
      </div>
      {text ? <div className={styles.text}>{text}</div> : null}
    </AscGenericCard>
  );
}
